module.exports = __webpack_public_path__ + "img/home-2.a143b945.png";